import React, { useState } from 'react';

import { DepNftAsset, DepNftAssetLoader } from '@pkg/components/deprecated';
import { useGetCollectionTokensV2 } from '@pkg/hooks';
import { type SupportedChain } from '@pkg/types';

import { CollectionLink } from '@app/pages/Collection/components/CollectionLink';

import { CollectionAsset, SingleWrapper, Wrapper } from './styles';

interface CardPricesProps {
    slug?: string;
    fallbackImage?: string;
    chain?: SupportedChain;
}

interface SingleAssetProps {
    slug?: string;
    chain?: SupportedChain;
    imageUrl?: string;
    fallbackImage?: string;
}

export const SingleCollectionCard = ({ slug, chain, fallbackImage, imageUrl }: SingleAssetProps) => {
    const [error, setError] = useState(false);
    const image = error ? fallbackImage : imageUrl || fallbackImage;
    const linkDisabled = chain !== 'ethereum'; // TODO: Remove this once we support multichain collections page

    return (
        <CollectionLink chain={chain} slug={slug} disablePeek>
            <SingleWrapper $disabled={linkDisabled}>
                <DepNftAssetLoader isLoading={!image}>
                    <DepNftAsset
                        onError={() => setError(true)}
                        imageUrl={image}
                        displayVideo
                        videoControls
                        objectFit={'contain'}
                    />
                </DepNftAssetLoader>
            </SingleWrapper>
        </CollectionLink>
    );
};

export const CardCollectionStack = ({ slug, chain, fallbackImage }: CardPricesProps) => {
    const { data: rawTokenData, isLoading } = useGetCollectionTokensV2({
        chain,
        slug: slug || '',
        //   daas doesn't allow a limit lower than 50:(
    });

    const tokensData = rawTokenData?.pages[0];
    const mashedImage = tokensData?.tokens?.[0]?.image_url;

    const mashedImage1 = tokensData?.tokens?.[1]?.image_url || '';
    const mashedImage2 = tokensData?.tokens?.[2]?.image_url || '';

    return (
        <CollectionLink chain={chain} slug={slug} disablePeek>
            <Wrapper>
                <CollectionAsset $stackOrder={2}>
                    <DepNftAssetLoader isLoading={!mashedImage || isLoading}>
                        <DepNftAsset imageUrl={mashedImage1} videoUrl={undefined} fallback={fallbackImage} />
                    </DepNftAssetLoader>
                </CollectionAsset>

                <CollectionAsset $stackOrder={1}>
                    <DepNftAssetLoader isLoading={!mashedImage1 || isLoading}>
                        <DepNftAsset imageUrl={mashedImage1} videoUrl={undefined} fallback={fallbackImage} />
                    </DepNftAssetLoader>
                </CollectionAsset>

                <CollectionAsset $stackOrder={0}>
                    <DepNftAssetLoader isLoading={!mashedImage2 || isLoading}>
                        <DepNftAsset imageUrl={mashedImage2} videoUrl={undefined} fallback={fallbackImage} />
                    </DepNftAssetLoader>
                </CollectionAsset>
            </Wrapper>
        </CollectionLink>
    );
};
